import { c as _c } from "react/compiler-runtime";
import { Input, type InputProps, type InputRef } from 'antd';
import type React from 'react';
import type { FC } from 'react';
import { cn } from '@/libs/utils';
interface AuthInputProps extends InputProps {
  label: string;
  errorMessage?: string;
  classNames?: {
    input?: string;
    label?: string;
    error?: string;
  };
  inputRef?: React.Ref<InputRef>;
}
export const AuthInput: FC<AuthInputProps> = t0 => {
  const $ = _c(26);
  let classNames;
  let errorMessage;
  let inputRef;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      errorMessage,
      classNames,
      inputRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = classNames;
    $[2] = errorMessage;
    $[3] = inputRef;
    $[4] = label;
    $[5] = props;
  } else {
    classNames = $[1];
    errorMessage = $[2];
    inputRef = $[3];
    label = $[4];
    props = $[5];
  }
  const t1 = classNames?.label;
  let t2;
  if ($[6] !== t1) {
    t2 = cn("flex flex-col gap-1 text-base text-[#AAAAB6]", t1);
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = errorMessage ? "#ED3F3F" : "#FFFFFF1A";
  let t4;
  if ($[8] !== t3) {
    t4 = {
      borderColor: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = classNames?.input;
  let t6;
  if ($[10] !== t5) {
    t6 = cn("h-[42px] w-full rounded-lg border-2 px-[11px]", t5);
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = errorMessage ? "error" : undefined;
  let t8;
  if ($[12] !== inputRef || $[13] !== props || $[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t8 = <Input ref={inputRef} size="large" style={t4} className={t6} status={t7} {...props} />;
    $[12] = inputRef;
    $[13] = props;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== classNames?.error || $[19] !== errorMessage) {
    t9 = errorMessage && <span className={cn("text-[14px] text-base text-[#ED3F3F]", classNames?.error)}>{errorMessage}</span>;
    $[18] = classNames?.error;
    $[19] = errorMessage;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== label || $[22] !== t2 || $[23] !== t8 || $[24] !== t9) {
    t10 = <label className={t2}>{label}{t8}{t9}</label>;
    $[21] = label;
    $[22] = t2;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};